apiWidgets = angular.module('api.widget', [])

apiWidgets.service 'Widget', ["$state", "Restangular", "$rootScope", ($state, Restangular, $rootScope) ->

  if $state.includes("email.page.editor")
    _widgets = "email_widgets"
  else
    _widgets = "widgets"

  widgets =
    getAll: ->
      Restangular.one("widgets").get()
    get: (type) ->
      Restangular.all("widgets").one(type).get()
    createImage: (image) ->
      Restangular.all("images").post image
    updateImage: (image) ->
      Restangular.all("images").one(image.id).customPUT image
    create: (sectionId, widgetType, sectionIsTemplate) ->
      Restangular.all("sections").one(sectionId).all(_widgets).post type: widgetType
    updateForm: (sectionId, widget) ->
      widget.form_fields_attributes = _.map widget.form_fields_attributes, (o) -> return _.omit o, 'optionsAdded'
      Restangular.all("sections").one(sectionId).all(_widgets).one(widget.id).customPUT widget
    update: (sectionId, widget) ->
      Restangular.all("sections").one(sectionId).all(_widgets).one(widget.id).customPUT widget
    updateForMixer: (sectionId, widget) ->
      Restangular.all("sections").one(sectionId).all("widgets").one(widget.id).all("update_for_mixer").customPUT widget
    clone: (sectionId, widgetId) ->
      Restangular.all("sections").one(sectionId).all(_widgets).one(widgetId).all("clone").post()
    getYoutubeHtml: (sectionId, url) ->
      Restangular.all("sections").one(sectionId).all(_widgets).all("video").one("new").get video_url: url
    createItem: (sectionId, widgetId, params) ->
      Restangular.all("sections").one(sectionId).all(_widgets).one(widgetId).customPUT params
    getWidget: (sectionId, widgetId) ->
      Restangular.all("sections").one(sectionId).all(_widgets).one(widgetId).get()
    sortFormFields: (formId, fieldsIds) ->
      Restangular.all("/forms/#{formId}/fields/sort").post {fields: fieldsIds}
    sortSubscribeFormFields: (formId, fieldsIds) ->
      Restangular.all("/subscribe_forms/#{formId}/fields/sort").post {fields: fieldsIds}
    sortProductItems: (productId, productItemsIds) ->
      Restangular.all("/products/#{productId}/product_items/sort").post {product_items: productItemsIds}
    destroyProductItem: (productId, productItemId) ->
      Restangular.all("/products/#{productId}/product_items/#{productItemId}").customDELETE()
    createProductItemRow: (productId, productItemId, params) ->
      Restangular.all("/products/#{productId}/product_items/#{productItemId}").customPUT params
    getVideoHtml: (sectionId, url) ->
      Restangular.all("sections").one(sectionId).all(_widgets).all("video").one("new").get video_url: url
    getImagesByTag: (tag, page) ->
      Restangular.one("images").get tag: tag, page: page
    getImages: (page) ->
      Restangular.one("images").get page: page
    getImagesTags: ->
      Restangular.one("images/tags").getList()
    remove: (image) ->
      Restangular.one("images/#{image.id}").customDELETE()

  widgets
]



// WEBPACK FOOTER //
// ./src/app/editor/api/widget.coffee